module.exports = __webpack_public_path__ + "static/scholarships.c75f74de.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/assets/scholarships.jpg
// module id = 7151
// module chunks = 165208297294940